export const questionNames = Object.freeze({
  repeatGroup: 'repeat_group'
})
